import { render, staticRenderFns } from "./InboxPage.vue?vue&type=template&id=e640ebea&scoped=true&"
import script from "./InboxPage.vue?vue&type=script&lang=js&"
export * from "./InboxPage.vue?vue&type=script&lang=js&"
import style0 from "./InboxPage.vue?vue&type=style&index=0&id=e640ebea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e640ebea",
  null
  
)

export default component.exports